export default function launchDarklyLogger() {
  return {
    debug: () => {},
    error: msg => console.error(msg),
    info: () => {},
    warn: () => {}
  };
}
